import { IconButton } from "@/components/ui/icon-button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@/components/ui/tooltip";

const HeaderWithTooltip = ({
  icon: Icon,
  tooltip
}: {
  icon: React.ComponentType;
  tooltip: string;
}) => (
  <div style={{ pointerEvents: "auto" }}>
    <Tooltip>
      <TooltipTrigger asChild>
        <IconButton
          variant="iconNoBg"
          iconColor="secondary"
          size="sm"
          type="button"
          style={{ pointerEvents: "auto" }}
        >
          <Icon />
        </IconButton>
      </TooltipTrigger>
      <TooltipContent side="top" sideOffset={4}>
        {tooltip}
      </TooltipContent>
    </Tooltip>
  </div>
);
export default HeaderWithTooltip;
